import {
  booleanAttribute,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  inject,
} from '@angular/core';
import { MaterialModule } from '@fullyops/shared/material.module';
import { I18NextCapPipe } from 'angular-i18next';

export type FormSectionStatus = 'none' | 'done' | 'error';

/**
 * One titled group of a form, as a card whose header describes the group. The title and description are
 * rendered verbatim. Inside a `fo-sectioned-form`, the section also appears in its index, with its status.
 *
 * With `showNext`, the card ends with a Next button that only emits `next`: the parent decides what comes
 * next, typically moving on to the following section.
 */
@Component({
  selector: 'fo-form-section',
  templateUrl: './form-section.component.html',
  styleUrl: './form-section.component.scss',
  imports: [MaterialModule, I18NextCapPipe],
  host: { '[id]': 'sectionId', '[class.locked]': 'locked' },
})
export class FormSectionComponent {
  readonly element = inject<ElementRef<HTMLElement>>(ElementRef);

  @Input({ required: true }) sectionId = '';
  @Input({ required: true }) title = '';
  @Input() description = '';
  @Input() icon = '';
  @Input() status: FormSectionStatus = 'none';
  @Input() errorCount = 0;
  /** Not reached yet: hidden, while still listed in the index. */
  @Input({ transform: booleanAttribute }) locked = false;
  @Input({ transform: booleanAttribute }) showNext = false;
  @Output() next = new EventEmitter<void>();
}
